import LeaveTypeList from '@/controllers/leave_type/leave-type-list.js';

export default {
  extends: LeaveTypeList,
}
